import { z } from 'zod';
import { zCents, zDate, zId, zReason } from './common';

export const BankImportBody = z.object({
  format: z.enum(['csv', 'camt053']),
  fileName: z.string().max(200).optional(),
  content: z.string().min(1).max(10_000_000),
  csv: z.object({ delimiter: z.string().max(1).default(';'), decimal: z.enum([',', '.']).default(','), columns: z.object({ bookingDate: z.string(), amount: z.string(), name: z.string().optional(), iban: z.string().optional(), purpose: z.string() }) }).optional(),
});
export const MatchTxBody = z.object({ tenancyId: zId, saveRule: z.boolean().default(false) });
/** `sendEmail`: the letter goes to the contract parties by e-mail right away (consent, address, daily mail limit). */
export const DunningBody = z.object({ tenancyId: zId, level: z.union([z.literal(1), z.literal(2), z.literal(3)]), feeCents: zCents.min(0).default(0), dueDate: zDate, preview: z.boolean().default(true), sendEmail: z.boolean().default(false) });
export const ManualPaymentBody = z.object({ date: zDate, amountCents: zCents.positive(), note: z.string().max(200).optional() });
/** Reverse a booked payment: a counter entry in the ledger (append-only), reason in the entry and the audit log. */
export const ReversePaymentBody = z.object({ reason: zReason });
/**
 * Opening balance of a tenancy (docs/15 #58, taking over mid-year): Stichtag + amount, positive = the tenant owes
 * (Rückstand), negative = credit (Guthaben), 0 removes the active one. Replacing books a counter entry for the active
 * one and a new entry (append-only), `reason` goes to the audit log only.
 */
export const OpeningBalanceBody = z.object({
  date: zDate,
  amountCents: zCents.refine((v) => Math.abs(v) <= 100_000_000, { message: 'Betrag zu groß' }),
  note: z.string().trim().max(200).optional(),
  reason: z.string().trim().max(500).optional(),
});
